import { frontendURL } from '../../../helper/URLHelper';
import CalendarView from './CalendarView.vue';
import CalendarTelaoView from './CalendarTelaoView.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/calendar'),
    name: 'google_calendar',
    meta: {
      permissions: ['administrator', 'agent'],
    },
    component: CalendarView,
  },
  {
    // Endereço fixo para salvar como favorito na TV: se ela reiniciar, volta direto aqui.
    path: frontendURL('accounts/:accountId/calendar/telao'),
    name: 'google_calendar_telao',
    meta: {
      permissions: ['administrator', 'agent'],
    },
    component: CalendarTelaoView,
  },
];
